import { FC } from 'react';
import ListingCardPlaceholder from '../ListingCardPlaceholder';
import styles from './ListingCardPlaceholderList.module.scss';

const placeholderComponents = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];

const ListingCardPlaceholderList: FC = () => (
  <div className={styles.root}>
    {placeholderComponents.map(({ id }) => (
      <ListingCardPlaceholder key={id} />
    ))}
  </div>
);

export default ListingCardPlaceholderList;
